import styled from "styled-components";

export const Wrapper = styled.div`

`;

export const ArtistWrapper = styled.div`
border: var(--defOutline);
`;